import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    root: {
        border: '2px dashed #E9D5FF',
        backgroundColor: '#E5E7EB',
        padding: '24px',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        width: '100%',
        height: '100%',
        zIndex: 9,
        display: 'flex',
        gap: '8px',
        flexDirection: 'column',
        justifyContent: 'center',
        borderRadius: '8px',
    },
    iconContainer: {
        borderRadius: '100%',
        backgroundColor: '#F3E8FF',
        padding: '8px',
        width: '64px',
        height: '64px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '0 auto',
    },
    title: {
        fontWeight: '500',
        fontSize: '18px',
        color: '#111827',
    },
    description: {
        fontWeight: '400',
        fontSize: '16px',
        color: '#4B5563',
    },
    textLeft: {
        textAlign: 'left',
    },
    domainAlert: {
        maxWidth: '600px',
        margin: '0 auto',
        color: '#7E22CE',
        background: '#FAF5FF',
        border: '1px solid #E9D5FF',
    },
    importAlert: {
        maxWidth: '600px',
        margin: '0 auto',
        color: '#15803D',
        background: '#F0FDF4',
        border: '1px solid #BBF7D0',
    },
    paymentAlert: {
        maxWidth: '600px',
        margin: '0 auto',
        color: '#1E40AF',
        background: '#EFF6FF',
        border: '1px solid #BFDBFE',
    },
    checkList: {
        listStyle: 'none',
        paddingLeft: 0,
    },
    checkListItem: {
        position: 'relative',
        paddingLeft: '1.8em',
        marginBottom: '0.5em',
        '&::before': {
            content: '"✔"',
            position: 'absolute',
            left: 0,
            color: '#15803D',
            fontWeight: 'bold',
        },
    },
}));

export default useStyles;
